import { render, staticRenderFns } from "./couchImageryDbManagement_item.vue?vue&type=template&id=f6da88f2"
import script from "./couchImageryDbManagement_item.vue?vue&type=script&lang=js"
export * from "./couchImageryDbManagement_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports